import { render, staticRenderFns } from "./OtherPromotion.vue?vue&type=template&id=4f7eff9a&"
import script from "./OtherPromotion.vue?vue&type=script&lang=js&"
export * from "./OtherPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports